AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "BaseSection");

AoPS.Ebooks.Models.BaseSection = (function () {
	// Dependencies
	var EbkMBase = AoPS.Ebooks.Models.Base;

	return EbkMBase.BaseModel.extend({
		id_attribute: "fragment_id",
		defaults: {
			fragment_code: "",
			number: "",
			title_html: "",
			order: -1,
			html: "",
			is_hard: false,
			edge: false,
			previous_id: 0,
			next_id: 0,
			previous_code: "",
			next_code: "",
			alcumus_subject_id: 0,
			alcumus_topic_id: 0,
		},
	});
})();
